/**
 * Firebase App Check constants (main Tranzit SPA).
 * Mirror: backend/src/config/appCheck.ts
 */

export const FIREBASE_APP_CHECK_RECAPTCHA_SITE_ENV = 'REACT_APP_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY' as const;

export const FIREBASE_APP_CHECK_DEBUG_TOKEN_ENV = 'REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN' as const;

export const FIREBASE_APP_CHECK_ENFORCE_FUNCTIONS = true as const;

export const FIREBASE_APP_CHECK_ENFORCE_FIRESTORE = true as const;

export const FIREBASE_APP_CHECK_CSP_SCRIPT_ORIGINS = [
  'https://www.google.com',
  'https://www.gstatic.com',
] as const;

export const FIREBASE_APP_CHECK_CSP_CONNECT_ORIGINS = [
  'https://firebaseappcheck.googleapis.com',
  'https://content-firebaseappcheck.googleapis.com',
  'https://www.google.com',
  'https://www.gstatic.com',
] as const;

export const FIREBASE_APP_CHECK_CSP_FRAME_ORIGINS = [
  'https://www.google.com',
  'https://www.recaptcha.net',
] as const;

/** Static CRA env reads (required for production bundle inlining). */
export function getFirebaseAppCheckRecaptchaSiteKey(): string {
  return (process.env.REACT_APP_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY || '').trim();
}

export function getFirebaseAppCheckDebugToken(): string {
  return (process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN || '').trim();
}

export function isFirebaseAppCheckConfigured(): boolean {
  return getFirebaseAppCheckRecaptchaSiteKey().length > 0;
}
